import { action, observable, reaction, makeObservable } from 'mobx';
import {Disposers, GuessServerTime, HttpPromiseState, logger} from '../../../lib/helpers';
import {DelayTimer} from '../../../lib/helpers/date/DelayTimer';
import {Classroom} from '../../classroom/models/classroom-models';
import {ClassroomLoaders} from '../../classroom/stores/classroom-loaders';
import {
  StudentScheduleClassroomResponse,
  StudentScheduleClassroomItem
} from 'domain/models/response-model';

export class StudentScheduleStore {
  @observable.ref
  classroomsState: HttpPromiseState<readonly Classroom[]> | null;

  @observable.ref
  scheduleClassroomsState: HttpPromiseState<StudentScheduleClassroomResponse> | null = null;

  classRooms: readonly Classroom[] | null = null;
  scheduledClassrooms: readonly StudentScheduleClassroomItem[] | null = null;
  readonly delay = new DelayTimer(5000)

  serverTime: GuessServerTime;

  private minimal: number | null;

  private readonly disposers = new Disposers();

  @observable.ref
  suggestedClassRoom: StudentScheduleClassroomItem | null = null;
  
  @observable.ref
  declinedAndSuggestedClassRoom: StudentScheduleClassroomItem | null = null;

  @observable.ref
  acceptClassRoom: StudentScheduleClassroomItem | null = null;

  constructor() {
    makeObservable(this);
    this.classroomsState = null;
    this.serverTime = new GuessServerTime();
    this.minimal = null;
    this.disposers.add(this.delay);
    this.disposers.add(this.serverTime);
    this.setup();
  }

  @action
  load = () => {
    if (this.scheduleClassroomsState?.isPending)
      return;
    this.delay.reset();
    this.scheduleClassroomsState = ClassroomLoaders.Student.getClassroomSchedule();
  };

  private setup() {
    this.disposers.add(reaction(
      () => this.scheduleClassroomsState?.value,
      this.updateMinimal
    ));
    this.disposers.add(reaction(
      () => [this.delay.reached, this.minimal, this.serverTime.now],
      this.refreshAfterDelay
    ));
  }

  @action
  updateMinimal = () => {
    this.minimal = null;
    if (this.scheduleClassroomsState?.isResolved !== true)
      return;
      this.scheduledClassrooms = this.scheduleClassroomsState.value.Events;
  };

  @action
  private refreshAfterDelay = () => {
    if (this.minimal === null)
      return;
    if (!this.serverTime.reached(this.minimal))
      return;
    if (!this.delay.reached)
      return;
    this.load();
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
